export default "__VITE_ASSET__DAUIjLKT__"